// Daftar isi Panduan Pengguna. Panduan ada DI LUAR aplikasi (layout sendiri, tanpa login) supaya
// tautannya bisa dikirim ke grup WhatsApp klien dan dibuka siapa saja. Artikel baru: tambahkan
// halamannya di src/views/panduan-*-page.vue, rutenya di router.js, lalu entrinya di sini.
export default [
  {
    judul: "Mulai",
    items: [{ name: "panduan", label: "Beranda Panduan", ringkas: "Daftar semua panduan." }],
  },
  {
    judul: "Akuntansi & Stok",
    items: [
      {
        name: "panduan-hpp-otomatis",
        label: "HPP Otomatis & Bulan Tertutup",
        ringkas:
          "Kapan HPP dihitung, bulan tertutup, nota pembelian yang terlambat, dan kapan tombol Hitung HPP manual boleh dipakai.",
      },
    ],
  },
  {
    judul: "Langganan",
    items: [
      {
        name: "panduan-masa-langganan",
        label: "Masa Langganan Aplikasi",
        ringkas: "Arti pesan \"Masa langganan aplikasi berakhir\", dan cara aplikasi terbuka lagi setelah perpanjangan dibayar.",
      },
    ],
  },
  {
    judul: "Billiard",
    items: [
      {
        name: "panduan-billiard-harga-menu",
        label: "Ubah Harga Meja & Daftar Menu",
        ringkas:
          "Mengubah harga sewa meja per jam, menambah/mengubah/menghapus menu makanan & minuman, harga promo, dan mengirimnya ke tablet.",
      },
    ],
  },
];
